import axios from './utils/axios';
import { utils } from 'gipsy-misc';

export var get = function get() {
  var endpoint = '/notifs';
  return axios.get(endpoint);
};

export var markAsRead = function markAsRead(ids) {
  var endpoint = '/notifs/read';
  var params = { id: ids.join(',') };
  endpoint = utils.request.appendToUrl(endpoint, params);
  return axios.post(endpoint);
};
//# sourceMappingURL=notifications.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/notifications.js
// module id = 1082
// module chunks = 0